// all api related to company should come here
import { api as axios } from "../shared/axios";
import useSWR from "swr";
import { API_URL } from "../shared/config";

const fetcher = (url) => axios.get(url);

export const useSubCompany = (id) => {
  const { data, error, mutate } = useSWR(id ? `${API_URL}/company/${id}/subsidiary/` : null, fetcher, {
    revalidateIfStale: false,
    revalidateOnFocus: true,
    revalidateOnReconnect: false,
    revalidateOnMount: true,
    dedupingInterval: 9_00_00,
    onErrorRetry: (error, key, config, revalidate, options) => {
      if (error.status === 404) return;
      return true;
    }
  } ); 
  return {
    subCompany: data?.data,
    isLoadingSubCompany: !error && !data,
    isErrorSubCompany: error,
    mutateSubCompany:mutate
  };
};

export const useCompanyReport = (id) => {
  const { data, error } = useSWR(id ? `${API_URL}/device/company/${id}/` : null, fetcher);

  return {
    data: data?.data,
    isLoadingData: !error && !data,
    isErrorData: error,
  };
};

export const useCompanyReportDeviceLists = (id, type, selectedRangeDate,statuses) => {
  const statusFilter = statuses?.length > 0 ? `&device_status=${statuses}` : "";
  const { data, error } = useSWR(
    id ? `${API_URL}/plant/${id}/report/${selectedRangeDate}&report_type=${type}${statusFilter}` : null,
    fetcher
  );

  return {
    data: data?.data,
    isLoadingData: !error && !data,
    isErrorData: error,
  };
};

export const downloadCSVCompanyTHP = async (payload) => {
  try {
    const request = await axios.post(`${API_URL}/device/report/csv/`, payload);
    return { data: request.data, error: undefined };
  } catch (error) {
    return { data: undefined, error: error };
  }
};

export const downloadDeviceReportCSV = async (deviceId,data) => {
  try {
    const request = await axios.post(`${API_URL}/device/${deviceId}/report/csv/`, data);
    return { data: request.data, error: undefined };
  } catch (error) {
    return { data: undefined, error: error };
  }
};

export const useCompanyReportDeviceInformation = ( id, type, statuses,selectedRangeDate ) => {
  const statusFilter = statuses?.length > 0 ? `&device_status=${statuses}` : "";


  const { data, error } = useSWR(id ? `${API_URL}/device/${id}/info/${selectedRangeDate}&device_type=${type}${statusFilter}` : null, fetcher );

  return {
    data: data?.data,
    isLoadingData: !error && !data,
    isErrorData: error,
  };
};


export const downloadVehicleOverviewReport = async (plant_id, selectedRange) => {
  const selectedRangeDate = selectedRange.slice(1);
  try {
    const request = await axios.get(`${API_URL}/plant/${plant_id}/report/?report_type=excel_vehicle_overview&${selectedRangeDate}`);
    return { data: request.data, error: undefined };
  } catch (error) {
    return { data: undefined, error: error };
  }
};

export const downloadChargerOverviewReport = async (plant_id, selectedRange) => {
  const selectedRangeDate = selectedRange.slice(1);
  try {
    const request = await axios.get(`${API_URL}/plant/${plant_id}/report/?report_type=excel_charger_overview&${selectedRangeDate}`);
    return { data: request.data, error: undefined };
  } catch (error) {
    return { data: undefined, error: error };
  }
}

export const downloadYearlyReport = async (plant_id, reportType, year) => {
  try {
    const request = await axios.get(
      `${API_URL}/plant/${plant_id}/report/?report_type=${reportType}&year=${year}`
    );
    return { data: request.data, error: undefined };
  } catch (error) {
    return { data: undefined, error: error };
  }
};